
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/liveintent",
      function () {
        return require("private-next-pages/destinations/liveintent.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/liveintent"])
      });
    }
  